export default "__VITE_ASSET__CbF9svbO__"